import ToggleItem from "../Common/ToggleItem";
import CommonToggleContainer from "../Common/CommonToggleContainer";
import Utils from "../Shared/Utils";
import UIManager from "../Shared/UIManager";
import NetworkLogic from "../Shared/NetworkLogic";
import SDKManager from "../Shared/SDKManager";
import { Global } from "../Shared/Global";
import AudioManager from "../Shared/AudioManager";
import WebViewManager from "../Shared/WebViewManager";
import EnterSoundManager from "../Shared/EnterSoundManager";
import Constant from "../Shared/Constant";
const i18n = require('LanguageData');

const { ccclass, property } = cc._decorator;

@ccclass
export default class CustomerServiceUI extends cc.Component {
    @property(CommonToggleContainer)
    toggleContainer: CommonToggleContainer = null

    @property(cc.Widget)
    wgtNode: cc.Widget = null

    @property(cc.Node)
    nodeList: cc.Node = null

    @property(cc.Node)
    nodeProblems: cc.Node = null

    @property(cc.Node)
    nodeTemplateChatItem: cc.Node = null

    @property(cc.Node)
    nodeTemplateQuestionItem: cc.Node = null

    @property(cc.Layout)
    lytContentChat: cc.Layout = null

    @property(cc.Layout)
    lytContentQuestion: cc.Layout = null

    customerTypeName: string = ""

    private _urlOnlineChat: string = ""
    private bhide = false;
    onLoad() {
        this.nodeList.active = false
        this.nodeProblems.active = false
        this.nodeTemplateChatItem.parent = null
        this.nodeTemplateQuestionItem.parent = null
        Utils.hideGameNode()
        cc.game.on(cc.game.EVENT_SHOW, this.onAppShow, this)
        cc.game.on(cc.game.EVENT_HIDE, this.onAppHide, this)

    }

    start() {
        if (cc.winSize.width / cc.winSize.height > 2) {
            this.wgtNode.left += Constant.BangLength;
        }
        UIManager.showLoadingUI()
        NetworkLogic.customServiceList(function (data) {
            UIManager.hideLoadingUI()
            this.createToggles(data)
        }.bind(this))
        EnterSoundManager.playSound("enter_kefu")
    }
    onAppShow(){

    }
    onAppHide(){
        this.bhide = true;
    }
    onDestroy() {
        this.nodeTemplateChatItem.destroy()
        this.nodeTemplateQuestionItem.destroy()
    }

    onBtnClick(event, userData) {
        if (userData === "back") {
            AudioManager.playSound("close")
            Utils.showGameNode()
            this.node.destroy()
        } else if (userData === "chat") {
            let id = event.target["ChatID"]

            if (event.target["ChatType"] === "Online") {
                if  (this._urlOnlineChat.indexOf("wpa1.qq.com") !== -1){//用网页打开
                    cc.sys.openURL(this._urlOnlineChat)
                }else{
                    let wvManager = cc.find("Canvas") && cc.find("Canvas").getComponent(WebViewManager)
                    if (wvManager) {
                        Utils.setOrientation("V")
                        wvManager.openOnlineKefu(this._urlOnlineChat)
                    }
                }
            } else if (event.target["ChatType"] === "QQ") {
                if (SDKManager.isInstall(SDKManager.UMSocialPlatformType.QQ)) {
                    cc.sys.openURL("mqq://im/chat?chat_type=wpa&uin={0}&version=1&src_type=web"["format"](id))
                } else {
                    UIManager.showToastUI(i18n.t('customer_text.not_ind_qq'), Global.ToastType.Warnning)
                }
            } else if (event.target["ChatType"] === "WECHAT") {
                Utils.copyText(id)
                UIManager.showConfirmUI(i18n.t('customer_text.jump_wx'), function () {
                    if (SDKManager.isInstall(SDKManager.UMSocialPlatformType.WechatSession)) {
                        cc.sys.openURL("weixin://")
                    } else {
                        UIManager.showToastUI(i18n.t('customer_text.not_ind_wx'), Global.ToastType.Warnning)
                    }
                }.bind(this))
            } else if (event.target["ChatType"] === "MT") {
                Utils.copyText(id)
                UIManager.showConfirmUI(i18n.t('customer_text.jump_mt'), function () {
                    if (!cc.sys.openURL("mtmessenger://")) {
                        UIManager.showLoadingUI()
                        NetworkLogic.getConfigValue("mtDownUrl", function (data) {
                            UIManager.hideLoadingUI()
                            cc.sys.openURL(data && data.value0 || "https://mtios.com")
                        }.bind(this))
                    }
                }.bind(this))
            }else if (event.target["ChatType"] === "whatsapp"){
                Utils.copyText(id);
                UIManager.showTipUI(i18n.t("HallUI.copy_succ"))

                // let url1 = "https://wa.me/" + id;
                //
                // UIManager.showConfirmUI(i18n.t('customer_text.jump_whatsapp'), function () {
                //     cc.sys.openURL(url1)
                //     this.scheduleOnce(function () {
                //         if (! this.bhide){
                //             UIManager.showToastUI(i18n.t('customer_text.no_whatsapp'), Global.ToastType.Warnning)
                //         }else {
                //             this.bhide = false;
                //         }
                //     }.bind(this),0.5)
                //
                // }.bind(this))
            }
            else if (event.target["ChatType"] === "telegram"){
                Utils.copyText(id)
                UIManager.showTipUI(i18n.t("HallUI.copy_succ"))
                // let url1 =  "https://telegram.me/" + id;
                // UIManager.showConfirmUI(i18n.t('customer_text.jump_telegram'), function () {
                //
                //     cc.sys.openURL(url1)
                //     this.scheduleOnce(function () {
                //         if(!this.bhide){
                //             UIManager.showToastUI(i18n.t('customer_text.no_telegram'), Global.ToastType.Warnning)
                //         }else {
                //             this.bhide = false;
                //         }
                //     }.bind(this),0.5)
                //
                // }.bind(this))
            }else if (event.target["ChatType"] === "Messenger"){
                Utils.copyText(id)
                UIManager.showTipUI(i18n.t("HallUI.copy_succ"))
                // let url = "fb-messenger://";
                // UIManager.showConfirmUI(i18n.t('customer_text.jump_Messenger'), function () {
                //     cc.sys.openURL(url)
                //     this.scheduleOnce(function () {
                //         if(! this.bhide){
                //             UIManager.showToastUI(i18n.t('customer_text.no_Messenger'), Global.ToastType.Warnning)
                //         }else {
                //             this.bhide = false;
                //         }
                //     }.bind(this),0.5)
                //
                // }.bind(this))
            }else if (event.target["ChatType"] === "Viber"){
                Utils.copyText(id)
                UIManager.showTipUI(i18n.t("HallUI.copy_succ"))

                // let url1 = `viber://pa?chatURI=<${id}>`
                // UIManager.showConfirmUI(i18n.t('customer_text.jump_Viber'), function () {
                //     cc.sys.openURL(url1)
                //     this.scheduleOnce(function () {
                //         if (!this.bhide){
                //             UIManager.showToastUI(i18n.t('customer_text.no_Viber'), Global.ToastType.Warnning)
                //         }else {
                //             this.bhide = false;
                //         }
                //     }.bind(this),0.5)
                //
                // }.bind(this))
            }

        }
    }

    onToggleSelected(toggle: ToggleItem) {
        this.nodeList.active = false
        this.nodeProblems.active = false

        let data = toggle.userData

        if (data["type"] === "Online") {
            if (data["list"][0]) {
                this._urlOnlineChat = data["list"][0].content
            }
            this.nodeList.active = true
            this.createChatItems(data["list"], data["type"])
        }  else if (data["type"] === "CJ") {
            this.nodeProblems.active = true
            this.createQuestionItems(data["list"])
        }else{
            this.nodeList.active = true
            this.createChatItems(data["list"], data["type"])
        }
    }

    //创建左侧toggle
    private createToggles(data) {
        let names = {
            Online: i18n.t('customer_text.Online'),
            QQ: i18n.t('customer_text.QQ'),
            WECHAT: i18n.t('customer_text.WECHAT'),
            MT: i18n.t('customer_text.MT'),

            CJ: i18n.t('customer_text.CJ'),
        }

        data.forEach(item => {
            let toggle = this.toggleContainer.addDefaultToggle(names[item.type] || item.type, item)
            if (this.customerTypeName ===  item.type) {
                this.toggleContainer.selectToggle(toggle)
            }
        });
    }

    //创建分页列表
    private createChatItems(items, type) {
        this.lytContentChat.node.destroyAllChildren()

        items.forEach(item => {
            let node = cc.instantiate(this.nodeTemplateChatItem)
            node.getChildByName("name").getComponent(cc.Label).string = item.customerName
            node.getChildByName("btn")["ChatID"] = item.content
            node.getChildByName("btn")["ChatType"] = type

            if (type === "Online") {
                node.getChildByName("id").getComponent(cc.Label).string = i18n.t('customer_text.Online')
            } else {
                node.getChildByName("id").getComponent(cc.Label).string = item.content
            }

            cc.loader.load(item.icon, function (err, texture) {
                if (!err && node && node.isValid) {
                    node.getChildByName("head").getComponent(cc.Sprite).spriteFrame = new cc.SpriteFrame(texture)
                }
            }.bind(this))
            node.parent = this.lytContentChat.node
        });
    }

    private createQuestionItems(items) {
        this.lytContentQuestion.node.destroyAllChildren()

        for (let i = 0; i < items.length; i++) {
            const item = items[i];
            let node = cc.instantiate(this.nodeTemplateQuestionItem)
            node.getChildByName("title").getComponent(cc.Label).string = i + 1 + "、" + item.content
            node.getChildByName("text").getComponent(cc.Label).string = item.icon
            node.parent = this.lytContentQuestion.node
        }
    }
}
